import { render, staticRenderFns } from "./load.vue?vue&type=template&id=2620b7b1&scoped=true"
import script from "./load.vue?vue&type=script&lang=js"
export * from "./load.vue?vue&type=script&lang=js"
import style0 from "./load.vue?vue&type=style&index=0&id=2620b7b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620b7b1",
  null
  
)

export default component.exports